import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getDoc, getDocs, query, where, doc, updateDoc, addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/config"; // Актуализирай това спрямо твоята Firebase конфигурация
import {
  getStorage,
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import TextInput from "./TextInput"; // Импортираме новия компонент
import BlockManager from "./BlockManager"; // Импортираме компонента за блокове
import LogoLoader from "./LogoLoader"; // Импортираме твоето лого за зареждане
import Modal from "./Modal"; // Импортираме модала

const LandingPageForm = ({ duplicateFrom = null }) => {
  const navigate = useNavigate();
  const { id } = useParams(); // Взима id на страницата за редакция
  const isEditMode = Boolean(id); // Проверява дали сме в режим на редакция

  const isDuplicateMode = !isEditMode && Boolean(duplicateFrom);
  const sourceId = id || duplicateFrom;
  const [sourceData, setSourceData] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageNotFound, setPageNotFound] = useState(false);
  const [blocks, setBlocks] = useState([]);
  const [blocksSectionTitle, setBlocksSectionTitle] = useState("");
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [description2, setDescription2] = useState("");
  const [disclaimer, setDisclaimer] = useState("");
  const [desktopImage, setDesktopImage] = useState("");
  const [mobileImage, setMobileImage] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [formGtagSendTo, setFormGtagSendTo] = useState("");
  const [formMetaEventType, setFormMetaEventType] = useState("track");
  const [formMetaEventName, setFormMetaEventName] = useState("");
  const [primaryButtonLabel, setPrimaryButtonLabel] = useState("");
  const [primaryButtonAction, setPrimaryButtonAction] = useState("url");
  const [primaryButtonUrl, setPrimaryButtonUrl] = useState("");
  const [primaryButtonTarget, setPrimaryButtonTarget] = useState("_self");
  const [primaryButtonStyle, setPrimaryButtonStyle] = useState("solid");
  const [secondaryButtonLabel, setSecondaryButtonLabel] = useState("");
  const [secondaryButtonAction, setSecondaryButtonAction] = useState("url");
  const [secondaryButtonUrl, setSecondaryButtonUrl] = useState("");
  const [secondaryButtonTarget, setSecondaryButtonTarget] = useState("_self");
  const [secondaryButtonStyle, setSecondaryButtonStyle] = useState("outlined");
  const [stickyContactButtonLabel, setStickyContactButtonLabel] = useState("");
  const [selectedContactFields, setSelectedContactFields] = useState([]);
  const [isPublished, setIsPublished] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageField, setImageField] = useState(null); // Полето, което редактираме (desktopImage или mobileImage)
  const [imageList, setImageList] = useState([]); // Списък с изображения от Firebase
  const [newImage, setNewImage] = useState(null); // За новото изображение
  const storage = getStorage(); // Инициализация на Firebase Storage
  const [imageToDelete, setImageToDelete] = useState(null); // Съхранява изображението за изтриване
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Управлява модала за потвърждение на изтриване
  const allContactFields = [
    "имена",
    "имейл",
    "телефон",
    "съобщение",
    "предпочитано представителство",
  ];

  // Функция за актуализиране на блок
  const updateBlock = (index, updatedBlock) => {
    const newBlocks = [...blocks];
    newBlocks[index] = updatedBlock;
    setBlocks(newBlocks);
  };

  // Функция за премахване на блок
  const removeBlock = (index) => {
    const newBlocks = blocks.filter((_, i) => i !== index);
    setBlocks(newBlocks);
  };

  const moveBlockUp = (index) => {
    if (index === 0) return;

    const newBlocks = [...blocks];
    [newBlocks[index - 1], newBlocks[index]] = [
      newBlocks[index],
      newBlocks[index - 1],
    ];
    setBlocks(newBlocks);
  };

  const moveBlockDown = (index) => {
    if (index === blocks.length - 1) return;

    const newBlocks = [...blocks];
    [newBlocks[index], newBlocks[index + 1]] = [
      newBlocks[index + 1],
      newBlocks[index],
    ];
    setBlocks(newBlocks);
  };

  useEffect(() => {
    if (sourceId) {
      const fetchLandingPage = async () => {
        try {
          const docRef = doc(db, "LandingPages", sourceId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setPageNotFound(false);
            setSourceData(data);

            // Задаване на стойности в state
            setTitle(data.title || "");
            setSlug(isDuplicateMode ? "" : data.slug || "");
            setDescription(data.description || "");
            setDescription2(data.description2 || "");
            setDisclaimer(data.disclaimer || "");
            setDesktopImage(data.desktopImage || "");
            setMobileImage(data.mobileImage || "");
            setFormTitle(data.formTitle || "");
            setFormGtagSendTo(data.formGtagSendTo || "");
            setFormMetaEventType(data.formMetaEventType || "track");
            setFormMetaEventName(data.formMetaEventName || "");
            setPrimaryButtonLabel(
              data.primaryButtonLabel ||
                (data.buttonUrl ? "Виж наличните автомобили" : "")
            );
            setPrimaryButtonAction(data.primaryButtonAction || "url");
            setPrimaryButtonUrl(data.primaryButtonUrl || data.buttonUrl || "");
            setPrimaryButtonTarget(data.primaryButtonTarget || "_self");
            setPrimaryButtonStyle(data.primaryButtonStyle || "solid");
            setSecondaryButtonLabel(data.secondaryButtonLabel || "");
            setSecondaryButtonAction(data.secondaryButtonAction || "url");
            setSecondaryButtonUrl(data.secondaryButtonUrl || "");
            setSecondaryButtonTarget(data.secondaryButtonTarget || "_self");
            setSecondaryButtonStyle(data.secondaryButtonStyle || "outlined");
            setStickyContactButtonLabel(data.stickyContactButtonLabel || "");
            setBlocksSectionTitle(data.blocksSectionTitle || "");
            setSelectedContactFields(data.contactFields || []);
            setIsPublished(isDuplicateMode ? false : data.isPublished || false);
            setBlocks(data.blocks || []);

            console.log("State updated successfully!"); // Лог за проверка
          } else {
            console.log("No such document!");
            setPageNotFound(true);
          }
        } catch (error) {
          console.error("Error fetching landing page:", error);
          setPageNotFound(true);
        } finally {
          setLoading(false); // Спираме зареждането
        }
      };
      fetchLandingPage();
    } else {
      setLoading(false); // Ако не сме в режим на редакция, спираме зареждането
    }
  }, [sourceId, isDuplicateMode]);

  // Функция за създаване или обновяване на лендинг страницата
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaveError("");
    const normalizedSlug = slug.trim();
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(normalizedSlug)) {
      setSaveError("Въведете slug с малки латински букви, цифри и тирета между думите.");
      return;
    }
    if (isDuplicateMode && normalizedSlug === sourceData.slug) {
      setSaveError("Копието трябва да има различен slug от оригиналната страница.");
      return;
    }
    setSaving(true);
    // Preserve content fields that may not yet have controls in this editor.
    const { id: sourceDocumentId, createdAt, updatedAt, ...copiedContent } = sourceData;

    const data = {
      ...(isDuplicateMode ? copiedContent : {}),
      title,
      slug: normalizedSlug,
      description,
      description2,
      disclaimer,
      desktopImage,
      mobileImage,
      formTitle,
      formGtagSendTo,
      formMetaEventType,
      formMetaEventName,
      primaryButtonLabel,
      primaryButtonAction,
      primaryButtonUrl,
      primaryButtonTarget,
      primaryButtonStyle,
      secondaryButtonLabel,
      secondaryButtonAction,
      secondaryButtonUrl,
      secondaryButtonTarget,
      secondaryButtonStyle,
      stickyContactButtonLabel,
      blocksSectionTitle,
      contactFields: selectedContactFields,
      isPublished,
      buttonUrl: primaryButtonUrl,
      blocks, // Включваме и блоковете при записването
      updatedAt: new Date(),
    };

    try {
      const matches = await getDocs(query(
        collection(db, "LandingPages"),
        where("slug", "==", normalizedSlug)
      ));
      if (matches.docs.some((page) => page.id !== id)) {
        setSaveError("Вече има страница с този slug. Изберете друг.");
        return;
      }
      if (isEditMode) {
        const docRef = doc(db, "LandingPages", id);
        await updateDoc(docRef, data);
      } else {
        // Използваме addDoc за създаване на нов документ с автоматично генерирано id
        await addDoc(collection(db, "LandingPages"), {
          ...data,
          createdAt: new Date(),
        });
      }
      navigate("/admin/landingpages");
    } catch (error) {
      console.error("Error saving landing page:", error);
      setSaveError("Страницата не беше записана. Опитайте отново.");
    } finally {
      setSaving(false);
    }
  };

  // Ако зареждаме данните, показваме LogoLoader
  if (loading) {
    return <LogoLoader />;
  }

  if (pageNotFound) {
    return (
      <p className="my-6 text-lg text-center text-red-600">
        Лендинг-страницата не беше намерена
      </p>
    );
  }

  // Функция за извличане на изображения от Firebase Storage
  const fetchImages = async (folder) => {
    setImageList([]); // Изчистване на стария списък
    const imagesRef = ref(storage, folder);
    const imageRefs = await listAll(imagesRef);
    const urls = await Promise.all(
      imageRefs.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef);
        console.log(`Извлечен URL: ${url}`); // Лог за проверка на URL
        return url;
      })
    );
    setImageList(urls);
  };

  // Функция за качване на ново изображение
  const handleUpload = async () => {
    if (!newImage) return;
    const folder =
      imageField === "desktopImage"
        ? "landing-images/desktop"
        : "landing-images/mobile"; // Определяме папката
    const imageRef = ref(storage, `${folder}/${newImage.name}`);
    await uploadBytes(imageRef, newImage);
    const url = await getDownloadURL(imageRef);
    setImageList((prev) => [...prev, url]); // Добавяме новото изображение към списъка
  };

  // Отваряне на модала и зареждане на изображенията
  const openImageModal = (field) => {
    setImageField(field);
    if (field === "desktopImage") {
      fetchImages("landing-images/desktop"); // Зареждаме изображенията от папката за десктоп
    } else {
      fetchImages("landing-images/mobile"); // Зареждаме изображенията от папката за мобилни устройства
    }
    setIsModalOpen(true);
  };

  // Избиране на изображение
  const selectImage = (url) => {
    if (imageField === "desktopImage") {
      setDesktopImage(url);
    } else {
      setMobileImage(url);
    }
    setIsModalOpen(false); // Затваряне на модала след избор
  };

  const confirmDeleteImage = (url) => {
    setImageToDelete(url); // Задаваме изображението за изтриване
    setIsModalOpen(false); // Затваряме текущия модал за избор на изображения
    setIsDeleteModalOpen(true); // Отваряме модала за потвърждение на изтриване
  };

  const handleDeleteImage = async () => {
    const imageRef = ref(storage, imageToDelete); // Препратка към изображението във Firebase Storage
    try {
      await deleteObject(imageRef); // Изтрива изображението от Firebase Storage
      setImageList((prev) => prev.filter((url) => url !== imageToDelete)); // Премахва изображението от списъка

      // Обнови съответното поле в зависимост от това кое изображение се изтрива
      const docRef = doc(db, "LandingPages", id); // Препратка към текущия документ

      if (imageToDelete === mobileImage) {
        setMobileImage(""); // Изчисти полето за mobileImage
        await updateDoc(docRef, { mobileImage: "" }); // Обнови Firestore документа
      } else if (imageToDelete === desktopImage) {
        setDesktopImage(""); // Изчисти полето за desktopImage
        await updateDoc(docRef, { desktopImage: "" }); // Обнови Firestore документа
      }

      setIsDeleteModalOpen(false); // Затваря модала за изтриване
      setImageToDelete(null); // Изчиства състоянието
    } catch (error) {
      console.error("Грешка при изтриване на изображението:", error);
    }
  };

  return (
    <>
      {isDuplicateMode && (
        <p className="mb-4 text-fordBlue">
          Съдържанието е копирано. Въведете нов slug и направете нужните корекции.
          Копието е непубликувано по подразбиране и ще се създаде при запис.
        </p>
      )}
      <form
        onSubmit={handleSubmit}
        className="w-full mx-auto text-left"
        id="landingPageForm"
      >
        <details open={isDuplicateMode || undefined} className="py-2 border-b border-gray-300">
          <summary className="uppercase text-fordBlue">
            Основна информация
          </summary>
          <div className="pl-4">
            <div className="grid grid-cols-2 gap-8">
              <div className="mt-8">
                <label className="block">
                  Основно изображение /за големи екрани/
                </label>
                <p className="text-sm text-gray-400">
                  Използвайте същото изображение, което е подготвено за карусела
                  на ford.bg. Препоръчва се размерът да е 1500х616 px и да няма
                  текст върху изображението.
                </p>
                {desktopImage && (
                  <div className="my-2">
                    <img
                      src={desktopImage}
                      alt="Desktop Preview"
                      className="object-cover w-auto h-32 border"
                    />
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => openImageModal("desktopImage")}
                  className="px-4 py-2 mt-2 border rounded text-fordBlue border-fordBlue"
                >
                  Избери или качи изображение
                </button>
              </div>

              <div className="mt-8">
                <label className="block">
                  Основно изображение /за мобилни устройства/
                </label>
                <p className="text-sm text-gray-400">
                  Използвайте същото изображение, което е подготвено за карусела
                  на ford.bg /780x960 px/. Ако не изберете изображение, ще се
                  използва това за големи екрани.
                </p>
                {mobileImage && (
                  <div className="my-2">
                    <img
                      src={mobileImage}
                      alt="Mobile Preview"
                      className="object-cover w-auto h-32 border"
                    />
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => openImageModal("mobileImage")}
                  className="px-4 py-2 mt-2 border rounded text-fordBlue border-fordBlue"
                >
                  Избери или качи изображение
                </button>
              </div>
            </div>
            <div className="mt-8">
              <TextInput
                label="Заглавие"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                helpText="Това заглавие ще се покаже в синьото поле под основната снимка на страницата"
              />
            </div>
            <div className="mt-8">
              <TextInput
                label="Slug"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                required
                helpText="Това е част от URL-адреса на страницатa, например: https://sale.ford.bg/landing/slug"
              />
            </div>
            <div className="mt-8">
              <label className="block">Описание 1</label>
              <textarea
                value={description}
                rows={6}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full px-4 py-2 mt-4 border border-gray-300 rounded"
              />
              <p className="mt-1 text-sm text-gray-500">
                Това е основния текст на страницата и се разполага
                непосредствено под заглавието /в тъмносиньото поле/
              </p>
            </div>
            <div className="mt-8">
              <label className="block">Описание 2 /Markdown/</label>
              <textarea
                value={description2}
                rows={10}
                onChange={(e) => setDescription2(e.target.value)}
                className="w-full px-4 py-2 mt-4 border border-gray-300 rounded"
              />
              <p className="mt-1 text-sm text-gray-500">
                Това поле поддържа Markdown и ще се покаже в отделен бял блок
                непосредствено под тъмносиньото поле. Можете да използвате
                абзаци, `**удебелен текст**`, `*italic*`, списъци, `#`
                подзаглавия и линкове от вида `[текст](https://example.com)`.
              </p>
              <pre className="p-4 mt-3 text-sm leading-6 text-left whitespace-pre-wrap rounded bg-gray-50 text-fordBlue">
{`## Защо да изберете този модел

**Новият Ford** съчетава комфорт и ефективност.

- до 376 км пробег
- бързо зареждане
- богато оборудване

[Виж повече](https://sale.ford.bg/)`}
              </pre>
              <p className="mt-1 text-sm text-gray-500">
                Ако оставите празен ред между два текста, те ще излязат като
                отделни абзаци.
              </p>
            </div>
            <div className="my-8 space-y-8">
              <div className="p-4 border rounded bg-gray-50">
                <h3 className="text-sm tracking-wide uppercase text-fordBlue">
                  Бутон 1
                </h3>
                <div className="mt-4">
                  <TextInput
                    label="Лейбъл"
                    value={primaryButtonLabel}
                    onChange={(e) => setPrimaryButtonLabel(e.target.value)}
                    helpText="Този бутон ще се рендира под синьото поле и над Описание 2."
                  />
                  <div className="mb-4">
                    <label className="block text-left">Тип на действие</label>
                    <select
                      value={primaryButtonAction}
                      onChange={(e) => setPrimaryButtonAction(e.target.value)}
                      className="w-full px-4 py-2 border rounded"
                    >
                      <option value="url">url</option>
                      <option value="scroll-to-form">scroll-to-form</option>
                    </select>
                  </div>
                  {primaryButtonAction === "url" ? (
                    <>
                      <TextInput
                        label="URL"
                        value={primaryButtonUrl}
                        onChange={(e) => setPrimaryButtonUrl(e.target.value)}
                      />
                      <div className="mb-4">
                        <label className="block text-left">
                          Отвори линка в
                        </label>
                        <select
                          value={primaryButtonTarget}
                          onChange={(e) => setPrimaryButtonTarget(e.target.value)}
                          className="w-full px-4 py-2 border rounded"
                        >
                          <option value="_self">същия таб</option>
                          <option value="_blank">нов таб</option>
                        </select>
                      </div>
                    </>
                  ) : (
                    <p className="mt-1 mb-4 text-sm text-gray-500">
                      Този бутон ще скролва до формата за контакт.
                    </p>
                  )}
                  <div className="mb-4">
                    <label className="block text-left">Стил</label>
                    <select
                      value={primaryButtonStyle}
                      onChange={(e) => setPrimaryButtonStyle(e.target.value)}
                      className="w-full px-4 py-2 border rounded"
                    >
                      <option value="solid">solid</option>
                      <option value="outlined">outlined</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="p-4 border rounded bg-gray-50">
                <h3 className="text-sm tracking-wide uppercase text-fordBlue">
                  Бутон 2
                </h3>
                <div className="mt-4">
                  <TextInput
                    label="Лейбъл"
                    value={secondaryButtonLabel}
                    onChange={(e) => setSecondaryButtonLabel(e.target.value)}
                  />
                  <div className="mb-4">
                    <label className="block text-left">Тип на действие</label>
                    <select
                      value={secondaryButtonAction}
                      onChange={(e) => setSecondaryButtonAction(e.target.value)}
                      className="w-full px-4 py-2 border rounded"
                    >
                      <option value="url">url</option>
                      <option value="scroll-to-form">scroll-to-form</option>
                    </select>
                  </div>
                  {secondaryButtonAction === "url" ? (
                    <>
                      <TextInput
                        label="URL"
                        value={secondaryButtonUrl}
                        onChange={(e) => setSecondaryButtonUrl(e.target.value)}
                      />
                      <div className="mb-4">
                        <label className="block text-left">
                          Отвори линка в
                        </label>
                        <select
                          value={secondaryButtonTarget}
                          onChange={(e) =>
                            setSecondaryButtonTarget(e.target.value)
                          }
                          className="w-full px-4 py-2 border rounded"
                        >
                          <option value="_self">същия таб</option>
                          <option value="_blank">нов таб</option>
                        </select>
                      </div>
                    </>
                  ) : (
                    <p className="mt-1 mb-4 text-sm text-gray-500">
                      Този бутон ще скролва до формата за контакт.
                    </p>
                  )}
                  <div className="mb-4">
                    <label className="block text-left">Стил</label>
                    <select
                      value={secondaryButtonStyle}
                      onChange={(e) => setSecondaryButtonStyle(e.target.value)}
                      className="w-full px-4 py-2 border rounded"
                    >
                      <option value="solid">solid</option>
                      <option value="outlined">outlined</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </details>
        <details className="py-2 border-b border-gray-300">
          <summary className="uppercase text-fordBlue">Акценти</summary>
          <div className="pl-4 mt-4">
            <TextInput
              label="Заглавие на секцията"
              value={blocksSectionTitle}
              onChange={(e) => setBlocksSectionTitle(e.target.value)}
              helpText="Това поле е опционално. Ако е попълнено, ще се покаже над блоковете в секцията Акценти."
            />
          </div>
          <BlockManager
            blocks={blocks}
            addBlock={() =>
              setBlocks([...blocks, { title: "", text: "", imageUrl: "" }])
            }
            updateBlock={updateBlock}
            removeBlock={removeBlock}
            moveBlockUp={moveBlockUp}
            moveBlockDown={moveBlockDown}
            className="pl-4 mt-8"
          />
        </details>
        <details className="py-2 border-b border-gray-300">
          <summary className="uppercase text-fordBlue">
            Форма за контакт
          </summary>
          <div className="pl-4 my-2">
            <TextInput
              label="Заглавие на формата за контакт"
              value={formTitle}
              onChange={(e) => setFormTitle(e.target.value)}
              helpText="Това заглавие ще се покаже над формата за контакт. Ако не въведете заглавие, такова няма да се визуализира."
            />
            <TextInput
              label="Текст на sticky бутона"
              value={stickyContactButtonLabel}
              onChange={(e) => setStickyContactButtonLabel(e.target.value)}
              helpText="Този текст ще се използва за плаващия бутон вдясно, който води към формата за контакт. Ако полето е празно, бутонът няма да се показва."
            />
            <div className="mt-8 p-4 border rounded bg-gray-50">
              <h3 className="text-sm tracking-wide uppercase text-fordBlue">
                Tracking при изпращане на формата
              </h3>
              <div className="mt-4">
                <TextInput
                  label="Google Ads send_to"
                  value={formGtagSendTo}
                  onChange={(e) => setFormGtagSendTo(e.target.value)}
                  helpText='Пример: AW-17814485194/HOcACLil1d0bEMrxza5C. Ако полето е празно, няма да се праща Google Ads conversion event.'
                />
              </div>
              <div className="mt-4">
                <label className="block text-left">Meta event тип</label>
                <select
                  value={formMetaEventType}
                  onChange={(e) => setFormMetaEventType(e.target.value)}
                  className="w-full px-4 py-2 border rounded"
                >
                  <option value="track">track</option>
                  <option value="trackCustom">trackCustom</option>
                </select>
              </div>
              <div className="mt-4">
                <TextInput
                  label="Meta event име"
                  value={formMetaEventName}
                  onChange={(e) => setFormMetaEventName(e.target.value)}
                  helpText='Пример: SubmitApplication, Lead или SubmitForm. Ако полето е празно, няма да се праща Meta event.'
                />
              </div>
            </div>
            <label className="block mt-4">
              Изберете полетата, които искате да включва формата за контакт:
            </label>
            {allContactFields.map((field) => (
              <div key={field} className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedContactFields.includes(field)}
                  onChange={() =>
                    setSelectedContactFields(
                      selectedContactFields.includes(field)
                        ? selectedContactFields.filter((f) => f !== field)
                        : [...selectedContactFields, field]
                    )
                  }
                  className="mr-2"
                />
                <label>{field}</label>
              </div>
            ))}
          </div>
        </details>
        <details className="py-2 border-b border-gray-300">
          <summary className="uppercase text-fordBlue">Публикуване</summary>
          <div className="pl-4">
            <div className="mt-2">
              <TextInput
                label="Дисклеймър"
                value={disclaimer}
                onChange={(e) => setDisclaimer(e.target.value)}
                helpText="Този текст обяснява специфичните условия на промоцията и ще се покаже с дребен шрифт под формата за контакт. Ако не въведете текст, такъв няма да се визуализира."
              />
            </div>
            <div className="mt-8">
              <label className="block">Публикувана</label>
              <input
                type="checkbox"
                checked={isPublished}
                onChange={(e) => setIsPublished(e.target.checked)}
                className="mr-2"
              />
              <label>Да</label>
            </div>
          </div>
        </details>
        {saveError && <p role="alert" className="mt-4 text-fordRed">{saveError}</p>}
        <button
          type="submit"
          disabled={saving}
          className="px-4 py-2 mt-8 tracking-wider text-white uppercase rounded bg-fordBlue disabled:opacity-50"
        >
          {saving ? "Записване…" : isEditMode ? "Запази промените" : isDuplicateMode ? "Създай копието" : "Създай страницата"}
        </button>
        <button
          type="button"
          disabled={saving}
          onClick={() => navigate("/admin/landingpages")}
          className="px-4 py-2 mt-8 ml-4 border rounded text-fordBlue border-fordBlue"
        >
          Отказ
        </button>

        {/* Модал за избор и качване на изображение */}
        {isModalOpen && (
          <Modal handleClose={() => setIsModalOpen(false)}>
            <div>
              <h2 className="p-4 text-lg text-white bg-fordBlue">
                Избери изображение
              </h2>
              <div
                className={`grid gap-4 mt-4 ${
                  imageField === "desktopImage" ? "grid-cols-4" : "grid-cols-3"
                }`}
              >
                {imageList.map((url, index) => (
                  <div key={index} className="p-2 border border-gray-300">
                    <img
                      src={url}
                      alt="Изображение"
                      className={`${
                        imageField === "desktopImage"
                          ? "w-full h-[111px]"
                          : "w-48 h-full"
                      }`}
                      loading="lazy"
                    />
                    <div className="flex justify-between mt-2">
                      <button
                        className="px-2 py-1 text-white rounded bg-fordBlue bottom-2 left-2"
                        onClick={() => selectImage(url)} // Избира изображение за лендинг страницата
                      >
                        Избери
                      </button>
                      <button
                        className="px-2 py-1 text-white rounded bg-fordRed bottom-2 right-2"
                        onClick={() => confirmDeleteImage(url)} // Стартира процеса на изтриване
                      >
                        Изтрий
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="pl-4 mt-8 bg-gray-100">
                <label>Качи ново изображение:</label>
                <input
                  type="file"
                  onChange={(e) => setNewImage(e.target.files[0])}
                  className="mt-2 ml-2 rounded border-slate-300"
                />
                <button
                  type="button"
                  onClick={handleUpload}
                  className="px-4 py-2 mt-2 border rounded text-fordBlue border-fordBlue hover:text-white hover:bg-fordBlue"
                >
                  Запиши в библиотеката
                </button>
              </div>
            </div>
          </Modal>
        )}
      </form>
      {isDeleteModalOpen && (
        <Modal handleClose={() => setIsDeleteModalOpen(false)}>
          <p className="mb-4 text-lg text-center">
            Сигурни ли сте, че искате да изтриете това изображение? Това
            действие е необратимо.
          </p>
          <div className="flex justify-center gap-4">
            <button
              className="px-4 py-2 text-white bg-red-600 rounded"
              onClick={handleDeleteImage} // Изтрива изображението при потвърждение
            >
              Изтрий
            </button>
            <button
              className="px-4 py-2 text-white bg-gray-600 rounded"
              onClick={() => setIsDeleteModalOpen(false)} // Затваря модала без действие
            >
              Отказ
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default LandingPageForm;
